<div class="step-container">
  <h2 class="step-title">Bienvenido/a</h2>
  <p class="step-subtitle">Antes de comenzar, por favor lea y acepte los Términos y Condiciones.</p>

  <div class="terms-box">
    <p>
      Al continuar con el proceso de registración, usted declara conocer y aceptar los
      Términos y Condiciones de uso del servicio de Credilow. Sus datos personales serán
      tratados conforme a la Ley N° 25.326 de Protección de Datos Personales de la
      República Argentina. La información proporcionada será utilizada exclusivamente
      para la evaluación crediticia y la prestación de los servicios solicitados.
    </p>
    <p>
      Usted autoriza a Credilow a verificar su identidad mediante el documento nacional
      de identidad, reconocimiento facial y demás medios que se le soliciten durante el
      proceso. Asimismo, autoriza la consulta de sus datos en las bases de información
      crediticia correspondientes.
    </p>
    <p>
      Credilow se compromete a proteger su información personal y a no compartirla con
      terceros sin su consentimiento, salvo que sea requerido por ley o autoridad competente.
    </p>
  </div>

  <div class="checkbox-container">
    <mat-checkbox [(ngModel)]="termsAccepted" color="primary">
      He leído y acepto los Términos y Condiciones
    </mat-checkbox>
  </div>

  <button
    mat-raised-button
    color="primary"
    class="action-button"
    [disabled]="!termsAccepted"
    (click)="onContinue()">
    Continuar
  </button>
</div>
